import React from "react";
// import LogoSvg from "assets/svg/logo";
import slotegrator from "assets/images/multilingual-seo-services/slotegrator.svg";

const Card1 = () => {
  return (
    <div
      className="right bg-white pl-[26px]  p-6 sm:w-[393px] relative sm:mt-0 mt-8 sm:rounded-[20px] sm:shadow-card2"
      // style="box-shadow: 0px 6px 10px #00000029; border-radius: 22px;"
    >
      <p className="font-medium text-[22px] font-sans">
        "Helpful
        <br /> cooperation"
      </p>
      <p className="text-[#00173A] font-sans leading-relaxed pt-5 hidden sm:block">
        {/* A translation company well equipped with <br /> knowledge of hundreds of
        different <br /> languages - speedy return & reasonably <br /> priced. */}
        The Tomedes' team I had worked with was helpful and responsive. The work
        has been done on time and the result was exactly <br /> what our company
        was looking for.
        <br /> Will continue cooperating in the <br /> future!
      </p>
      <p className="text-[#00173A] font-sans leading-relaxed pt-5 sm:hidden">
        The Tomedes' team I had worked with was <br /> helpful and responsive.
        The work has been <br /> done on time and the result was exactly <br />
        what our company was looking for.
        <br /> Will continue cooperating in the <br /> future!
      </p>
      <div className="pt-12">
        <img src={slotegrator} alt="" />
        <p className="text-[18px] font-medium font-secondary pt-3">Svetlana</p>
      </div>
    </div>
  );
};

export default Card1;
